import { DELETE_OR_UPDATE_PROFESSIONAL, PROFESSIONALS_BY_CENTER_URL, PROFESSIONALS_URL } from "../resources/ApiUrls";
import MyAxiosInstance from "../utils/MyAxiosInstance";

const getProfessionalsByCenter = (centerId) => MyAxiosInstance.get(PROFESSIONALS_BY_CENTER_URL(centerId));

const createProfessional = (professionalObj) => MyAxiosInstance.post(PROFESSIONALS_URL, professionalObj);

const deleteProfessional = (professionalId) => MyAxiosInstance.delete(DELETE_OR_UPDATE_PROFESSIONAL(professionalId))

const updateProfessional = (id, fieldsToUpdate) => MyAxiosInstance.patch(DELETE_OR_UPDATE_PROFESSIONAL(id), fieldsToUpdate)

const professionalConsts = { createProfessional, getProfessionalsByCenter, deleteProfessional, updateProfessional };

export default professionalConsts;
